import { HoodInsertChoice, HoodInsertModel, HoodModelNumber } from './Enums';

/**
 * The hood insert model.
 * The insert model is determined by the hood model number and the UI insert choice.
 * @param {string} modelNumber
 * @param {string} insertChoice
 * @returns {?string}
 */
export function hoodInsertModel(modelNumber, insertChoice) {
  switch (modelNumber) {
    case HoodModelNumber.LH900:
      return insertsFor900mm(insertChoice);

    case HoodModelNumber.LH1100:
      return insertsFor1100mm(insertChoice);

    case HoodModelNumber.LH1200:
      return insertsFor1200mm(insertChoice);

    case HoodModelNumber.LH1300:
      return insertsFor1300mm(insertChoice);

    case HoodModelNumber.LH1600:
      return insertsFor1600mm(insertChoice);

    case HoodModelNumber.LH1700:
      return insertsFor1700mm(insertChoice);

    case HoodModelNumber.LH2000:
      return insertsFor2000mm(insertChoice);

    case HoodModelNumber.LH2400:
      return insertsFor2400mm(insertChoice);

    default:
      return HoodInsertModel.modernAire_PSL1700;
  }
}

/**
 * Choose the insert model for a 900mm hood.
 * @param {string} insertChoice
 * @returns {?string}
 */
function insertsFor900mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL900,
    [HoodInsertChoice.ventAHoodSingle]: null,
    [HoodInsertChoice.ventAHoodDual]: null,
    [HoodInsertChoice.ventAHoodMagicLung]: null,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 1100mm hood.
 * @param {string} insertChoice
 * @returns {?string}
 */
function insertsFor1100mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL1100,
    [HoodInsertChoice.ventAHoodSingle]: null,
    [HoodInsertChoice.ventAHoodDual]: null,
    [HoodInsertChoice.ventAHoodMagicLung]: null,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 1200mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor1200mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL1200,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M28SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M28SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH228SLD,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 1300mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor1300mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL1300,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M28SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M28SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH228SLD,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 1600mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor1600mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL1700,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M34SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M34SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH234SLD,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 1700mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor1700mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL1700,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M40SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M40SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH240SLD,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 2000mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor2000mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL2000,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M46SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M46SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH346SLD,
  };

  return inserts[insertChoice];
}

/**
 * Choose the insert model for a 2400mm hood.
 * @param {string} insertChoice
 * @returns {string}
 */
function insertsFor2400mm(insertChoice) {
  const inserts = {
    [HoodInsertChoice.modernAire]: HoodInsertModel.modernAire_PSL2400,
    [HoodInsertChoice.ventAHoodSingle]: HoodInsertModel.ventAHood_M46SLD_single,
    [HoodInsertChoice.ventAHoodDual]: HoodInsertModel.ventAHood_M46SLD_dual,
    [HoodInsertChoice.ventAHoodMagicLung]: HoodInsertModel.ventAHood_BH346SLD,
  };

  return inserts[insertChoice];
}
